import { gql } from "lib/apolloClient";

export const gradeScaleToolFragment = {
  gradeScaleBasicDetails: gql`
    fragment gradeScaleBasicDetailsItem on GradeScale {
      id
      displayName
      templateName
      gradeScaleEntityDetails(filters: $gradingSetupEntityFilters) {
        id
      }
    }
  `,

  gradeScaleEntityDetail: gql`
    fragment gradeScaleEntityDetailItem on GradeScaleEntityDetail {
      id
      gradeScaleValues {
        id
        abbreviation
        label
        description
        displaySequence
        color
        gradeScaleValueScores {
          id
          minValue
          maxValue
          gradeValue
          isMasteryLevel
        }
      }
      gradeValueCalculateTypeDetail {
        id
        gradeValueCalculateType
      }
      gradeScale {
        id
        type
        displayName
        templateName
        description
        templateUid
        gradingType
        isUseForMastery
        isUseForCreditGPACalculation
        specialGradeTemplate {
          id
          displayName
          templateName
        }
        updatedAt
        isArchived
      }
    }
  `,

  gradeScaleEntityDetails: gql`
    fragment gradeScaleEntityDetailsItem on GradeScaleEntityDetail {
      id
      gradeScale {
        id
        gradingType
        displayName
        templateName
      }
      gradeScaleValues {
        id
        label
        description
        abbreviation
        displaySequence
        gradeScaleValueScores {
          id
          minValue
          maxValue
          gradeValue
          subjectLevel {
            id
            label
          }
        }
      }
      entityDetail {
        subjectId
      }
    }
  `,
};
